import React from 'react'
import styled from 'styled-components'

import Image from '../../atoms/Image'

const User = styled.div<{ compact: boolean }>`
  align-items: center;
  display: flex;
  border-bottom: 1px solid ${({ theme }) => theme.palette.border.light};
  padding: 0 0 ${({ compact }) => (compact ? '10px' : '16px')};
`

const UserImage = styled(Image)`
  object-fit: contain;
  width: 32px;
  height: 32px;
`

const UserName = styled.div<{ compact: boolean }>`
  color: ${({ theme }) => theme.palette.font.main};
  font-size: ${({ compact }) => (compact ? '12px' : '14px')};
  font-weight: bold;
  margin: 0 0 0 8px;
`

const ChildAge = styled.p<{ compact: boolean }>`
  font-size: ${({ compact }) => (compact ? '10px' : '12px')};
  font-weight: normal;
`

type Props = {
  childAge: string
  compact: boolean
  username: string
}

export default function ReviewList({ childAge, compact, username }: Props) {
  return (
    <User compact={compact}>
      <UserImage alt="ユーザーアイコン" filename="icon-user.png" />
      <UserName compact={compact}>
        {username}
        <ChildAge compact={compact}>{childAge}</ChildAge>
      </UserName>
    </User>
  )
}
